export default import.meta.ROLLUP_FILE_URL_IDJEz4Db2nUoD83Cly0$6g